import { createSelector } from 'reselect'
import { CommonState } from '~/store/types'

const selectLandingState = (state: CommonState) => state.landingPage || state.straitsXLandingPage

export const selectFlippers = createSelector(
  [selectLandingState],
  ({
    isArbitrumUIEnabled,
    isAvalancheUIEnabled,
    isBnbsmartUIEnabled,
    isEthereumUIEnabled,
    isHederaUIEnabled,
    isPolygonUIEnabled,
    isRippleUIEnabled,
    isTronUIEnabled,
    isUsdcMaticDepositEnabled,
    isUsdcMaticWithdrawalEnabled,
    isUsdtBep20DepositEnabled,
    isUsdtBep20WithdrawalEnabled,
    isUSDTBEP20UIEnabled,
    isUsdtTrc20DepositEnabled,
    isUsdtTrc20WithdrawalEnabled,
    isXsgdArbDepositEnabled,
    isXsgdArbWithdrawalEnabled,
    isXsgdAvaxDepositEnabled,
    isXsgdAvaxWithdrawalEnabled,
    isXsgdErc20DepositEnabled,
    isXsgdErc20WithdrawalEnabled,
    isXsgdHtsDepositEnabled,
    isXsgdHtsWithdrawalEnabled,
    isXsgdMaticDepositEnabled,
    isXsgdMaticWithdrawalEnabled,
    isXsgdXrpDepositEnabled,
    isXsgdXrpWithdrawalEnabled,
    isXsgdZrc2DepositEnabled,
    isXsgdZrc2WithdrawalEnabled,
    isXusdBep20DepositEnabled,
    isXusdBep20WithdrawalEnabled,
    isZilliqaUIEnabled,
    isXsgdSplDepositEnabled,
    isXsgdSplWithdrawalEnabled,
    isXusdSplDepositEnabled,
    isXusdSplWithdrawalEnabled,
    isSolanaUIEnabled,
    isXsgdSplUIEnabled,
    isXusdSplUIEnabled,
  }) => ({
    isArbitrumUIEnabled,
    isAvalancheUIEnabled,
    isBnbsmartUIEnabled,
    isEthereumUIEnabled,
    isHederaUIEnabled,
    isPolygonUIEnabled,
    isRippleUIEnabled,
    isTronUIEnabled,
    isUsdcMaticDepositEnabled,
    isUsdcMaticWithdrawalEnabled,
    isUsdtBep20DepositEnabled,
    isUsdtBep20WithdrawalEnabled,
    isUSDTBEP20UIEnabled,
    isUsdtTrc20DepositEnabled,
    isUsdtTrc20WithdrawalEnabled,
    isXsgdArbDepositEnabled,
    isXsgdArbWithdrawalEnabled,
    isXsgdAvaxDepositEnabled,
    isXsgdAvaxWithdrawalEnabled,
    isXsgdErc20DepositEnabled,
    isXsgdErc20WithdrawalEnabled,
    isXsgdHtsDepositEnabled,
    isXsgdHtsWithdrawalEnabled,
    isXsgdMaticDepositEnabled,
    isXsgdMaticWithdrawalEnabled,
    isXsgdXrpDepositEnabled,
    isXsgdXrpWithdrawalEnabled,
    isXsgdZrc2DepositEnabled,
    isXsgdZrc2WithdrawalEnabled,
    isXusdBep20DepositEnabled,
    isXusdBep20WithdrawalEnabled,
    isZilliqaUIEnabled,
    isXsgdSplDepositEnabled,
    isXsgdSplWithdrawalEnabled,
    isXusdSplDepositEnabled,
    isXusdSplWithdrawalEnabled,
    isSolanaUIEnabled,
    isXsgdSplUIEnabled,
    isXusdSplUIEnabled,
  })
)

export const selectIsCkaEnabled = createSelector([selectLandingState], state => state.isCkaEnabled)

export const selectIsDptApplied = createSelector([selectLandingState], state => state.isDptApplied)

export const selectIsDptRiskModalEnabled = createSelector(
  [selectLandingState],
  state => state.isDptRiskModalEnabled
)

export const selectIsTravelRuleDepositDeclarationEnabled = createSelector(
  [selectLandingState],
  state => state.isTravelRuleDepositDeclarationEnabled
)

export const selectIsTravelRuleAddrWhitelistingEnabled = createSelector(
  [selectLandingState],
  state => state.isTravelRuleAddrWhitelistingEnabled
)

export const selectTranfserFlowProperties = createSelector([selectLandingState], state => ({
  transferMethod: state.transferMethod,
  bankTransferNetwork: state.bankTransferNetwork,
  selectedCurrency: state.selectedCurrency,
  selectedBlockchain: state.selectedBlockchain,
  selectedBlockchainAddress: state.selectedBlockchainAddress,
  selectedBankAccount: state.selectedBankAccount,
  isConfirmOpen: state.isConfirmOpen,
  isFazzVaForDashboardEnabled: state.isFazzVaForDashboardEnabled,
}))
